import $ from 'jquery'
window.$ = window.jQuery = $;

// jQuery 4 removed APIs — shims for legacy plugins
$.proxy = $.proxy || function(fn, context) { return fn.bind(context); };
$.isFunction = $.isFunction || function(obj) { return typeof obj === 'function'; };
$.isArray = $.isArray || Array.isArray;
$.now = $.now || Date.now;
$.trim = $.trim || function(str) { return str == null ? '' : String.prototype.trim.call(str); };
$.fn.bind = $.fn.bind || function(eventType, handler) { return this.on(eventType, handler); };
$.fn.unbind = $.fn.unbind || function(eventType, handler) { return this.off(eventType, handler); };

import './bootstrap';

// Bugsnag

import Bugsnag from '@bugsnag/js';

const bugsnagApiKey = process.env.MIX_BUGSNAG_API_KEY || null
if (process.env.NODE_ENV === 'production' && bugsnagApiKey !== null) {
    Bugsnag.start({
        apiKey: bugsnagApiKey,
        releaseStage: process.env.NODE_ENV
    });
}

// Bootbox

import bootbox from 'bootbox';
window.bootbox = bootbox;

// Bootstrap Date Range Picker

import daterangepicker from 'bootstrap-daterangepicker';
window.daterangepicker = daterangepicker;

// Bootstrap Dialog

// import BootstrapDialog from 'bootstrap5-dialog';
// window.BootstrapDialog = BootstrapDialog;

// Bootstrap Table
require('bootstrap-table');

// Bootstrap Tooltip

import Tooltip from 'bootstrap/js/dist/tooltip';
window.Tooltip = Tooltip;

// Chart.js

import chart from 'chart.js/auto';
window.Chart = chart;

// Chosen
require('chosen-js');

// Flatpickr

import { Dutch } from 'flatpickr/dist/l10n/nl';
import { German } from 'flatpickr/dist/l10n/de';
import { French } from 'flatpickr/dist/l10n/fr';
import { Spanish } from 'flatpickr/dist/l10n/es';
import { Italian } from 'flatpickr/dist/l10n/it';

const languageMap = {
    nl: Dutch,
    de: German,
    fr: French,
    es: Spanish,
    it: Italian,
};

window.flatpickr = require('flatpickr');

window.flatpickrLanguageSwitch = (locale = 'en') => {
    return languageMap[locale] || undefined;
};

// Forms

import * as Forms from './app/forms';
window.Forms = Forms;

// jQuery - Date Time Picker
import 'jquery-datetimepicker'

// jQuery UI - autocomplete
import 'jquery-ui/ui/widgets/autocomplete.js';

// jQuery UI - sortable
import 'jquery-ui/ui/widgets/sortable.js';

// Google Api
const googleMapsApiKey = window.google_maps_api_key
    || process.env.MIX_GOOGLE_API_KEY
    || process.env.MIX_GOOGLE_MAPS_API_KEY
    || null;
window.googleApi = require('./app/googleApis').setupGoogleApi(googleMapsApiKey);

// Moment.js

import moment from 'moment';
window.moment = moment;

// NProgress

import nprogress from 'nprogress';
window.NProgress = nprogress;

// Sprintf-js

window.sprintf = require('sprintf-js').sprintf;
window.vsprintf = require('sprintf-js').vsprintf;

// SweetAlert2

import sweetalert2 from 'sweetalert2';
window.Swal = sweetalert2;

// Password Strength Meter
window.pwStrengthTranslator = require('./app/password.js').setupPwStrengthTranslator(locale)

// App

require('./app/actions.js');
require('./app/can.js');
require('./app/chosen.js');
require('./app/clock.js');
require('./app/colorCellStyle.js');
require('./app/datepicker.js');
require('./app/daterangepicker.js');
require('./app/dialog_google_maps.js');
require('./app/i18n.js');
require('./app/nbrogress.js');
require('./app/online.js');
require('./app/ready.js');
require('./app/tables.js');
require('./app/tabs.js');
require('./app/tooltip.js');
require('./app/validation.js');

// functions for Bootstrap Table

require('./app/dataTable/configureRowStyle');

// Formatters

require('./app/formatters/active.js');
require('./app/formatters/activity/log/detail.js');
require('./app/formatters/apis/exact/export/banks/detail.js');
require('./app/formatters/apis/exact/export/business_types/detail.js');
require('./app/formatters/apis/exact/export/detail.js');
require('./app/formatters/apis/exact/export/general_ledger_accounts/detail.js');
require('./app/formatters/apis/exact/export/payment_conditions/detail.js');
require('./app/formatters/apis/exact/export/products/detail.js');
require('./app/formatters/apis/exact/export/receivables_lists/detail.js');
require('./app/formatters/apis/exact/export/vat_codes/detail.js');
require('./app/formatters/apis/exact/import/detail.js');
require('./app/formatters/apis/exact/status_logs/detail.js');
require('./app/formatters/apis/mailchimp/requests/detail.js');
require('./app/formatters/apis/mailchimp/webhooks/requests/detail.js');
require('./app/formatters/address.js');
require('./app/formatters/amountFooter.js');
require('./app/formatters/audit/detail.js');
require('./app/formatters/contribution/detail.js');
require('./app/formatters/contribution/percentage.js');
require('./app/formatters/avatar.js');
require('./app/formatters/boolean.js');
require('./app/formatters/contribution.js');
require('./app/formatters/country/icon.js');
require('./app/formatters/delete.js');
require('./app/formatters/detail');
require('./app/formatters/document.js');
require('./app/formatters/document/category.js');
require('./app/formatters/document/download.js');
require('./app/formatters/document/icon.js');
require('./app/formatters/download.js');
require('./app/formatters/duplicate.js');
require('./app/formatters/edit.js');
require('./app/formatters/email.js');
require('./app/formatters/fontAwesome.js');
require('./app/formatters/googleMaps.js');
require('./app/formatters/jsonDetail.js');
require('./app/formatters/language/icon.js');
require('./app/formatters/loginAs.js');
require('./app/formatters/mobile.js');
require('./app/formatters/notification/markAsRead');
require('./app/formatters/option.js');
require('./app/formatters/percentage.js');
require('./app/formatters/phone.js');
require('./app/formatters/product.js');
require('./app/formatters/relation.js');
require('./app/formatters/role.js');
require('./app/formatters/rowStyle.js');
require('./app/formatters/sales/invoice/download.js');
require('./app/formatters/show.js');
require('./app/formatters/sortable.js');
require('./app/formatters/tags.js');
require('./app/formatters/url.js');
require('./app/formatters/visible');
require('./app/formatters/website.js');
require('./app/formatters/whitespace');

// Functions

require('./app/functions/is_empty.js');
require('./app/functions/number_format_to_decimal.js');
require('./app/functions/number_format.js');
